import React, { Component } from 'react';
import './map.css';
import Mapir from 'mapir-react-component';
import { mapApiKey } from './../../config';

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        'x-api-key': mapApiKey, //Mapir api key
        'Mapir-SDK': 'reactjs',
      },
    };
  },
});
export default class MapFooter extends Component {
  render() {
    return (
      <div className="map">
        <Mapir
          center={[51.422681, 35.732544]}
          Map={Map}
          apiKey={mapApiKey}
          zoom={[15]}
          containerStyle={{
            height: '100%',
            width: '100%',
            borderRadius: '10px',
          }}
        >
          <Mapir.Marker
            coordinates={[51.422681, 35.732544]}
            anchor="bottom"
          ></Mapir.Marker>
        </Mapir>
      </div>
    );
  }
}
